import React from 'react'

export default function twentyThirtyVision() {
    return (
        <div className="container-fluid rtl">
            <h1 className="block-title text-center title mb-5 mt-5 ">
            دور هاد في رؤية 2030  </h1>
            <div className="row justify-content-center my-5">
                <div className="col-12 col-md-8 mr-auto ">
                    <p className="twenty-thirty-p">يعد الاقتصاد المزدهر أحد الأسس الرئيسة لرؤية المملكة العربية السعودية 2030، وقد رسخت الرؤية الطموحة دور مساحات العمل المشتركة ومسرعات وحاضنات الأعمال وأسهمت في نموها، ورفع كفائتها وتوجيه الاهتمام المشترك لتطويرها ونموها، لما تشكله المنشآت الصغيرة والمتوسطة من أهمية كبيرة في دفع عجلة التنمية الاقتصادية على الصعيد العالمي والمحلي</p>
                </div>
                <div className="col-12 col-md-4">
                <div className="services-header">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            <div className="services-icon-circle4">
                                <h2 className="services-icon my-auto"></h2>
                            </div>
                            </div>
                        </div>
                            
                </div>
                <div className="col-12 my-3g"></div>
                <div className="col-12 col-md-8 ml-auto order-1 ">
                    <p className="twenty-thirty-p-1">يعد الاقتصاد المزدهر أحد الأسس الرئيسة لرؤية المملكة العربية السعودية 2030، وقد رسخت الرؤية الطموحة دور مساحات العمل المشتركة ومسرعات وحاضنات الأعمال وأسهمت في نموها، ورفع كفائتها وتوجيه الاهتمام المشترك لتطويرها ونموها، لما تشكله المنشآت الصغيرة والمتوسطة من أهمية كبيرة في دفع عجلة التنمية الاقتصادية على الصعيد العالمي والمحلي</p>
                </div>
                <div className="col-12 col-md-4">
                <div className="services-header">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            <div className="services-icon-circle4">
                                <h2 className="services-icon my-auto"></h2>
                            </div>
                            </div>
                        </div>
                            
                </div>
           {/*  <div className="col-12 col-md-6 ">
                        <div className="services-header">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="services-icon-circle4">
                            
                                <h2 className="services-icon my-auto">١.</h2>
                                
                            </div>
                           
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            </div>
                        </div>
                        
                        <div className="services-body">
                        يعد الاقتصاد المزدهر أحد الأسس الرئيسة لرؤية المملكة العربية السعودية 2030، وقد رسخت الرؤية الطموحة دور مساحات العمل المشتركة ومسرعات وحاضنات الأعمال وأسهمت في نموها، ورفع كفائتها وتوجيه الاهتمام المشترك لتطويرها ونموها، لما تشكله المنشآت الصغيرة والمتوسطة من أهمية كبيرة في دفع عجلة التنمية الاقتصادية على الصعيد العالمي والمحلي
                        
                        </div>
                    </div>



                    <div className="col-12 col-md-6">
                        <div className="services-header">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="services-icon-circle4">
                            
                                <h2 className="services-icon my-auto">٢.</h2>
                                
                            </div>
                           
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            </div>
                        </div>
                        
                        <div className="services-body">
                        من هنا يأتي دور شركة هاد مرشد الأعمال لما له من أثر بالغ في إرشاد المشاريع الناشئة، والمساهمة في نموها ، إذ تعد شركة هاد مرشد الأعمال من أهم مسرعات الأعمال المتخصصة في إسناد الخدمات المساندة لقطاع المنشآت الصغيرة والمتوسطة، حيث تنفرد بتقديم خدمات الإسناد الكامل أو الجزئي عبر خدمات تكاملية تساهم في منح أصحاب الأعمال وقت أكبر للتفرغ لإدارة أعمالهم وتطويرها
                        </div>
                    </div> */}
                </div>
                   {/*  <div className="row justify-content-center bg-alt">
                    <div className="container py-5">
                        <div className="col-12 col-md-6 ">
                <div className="services-header mx-auto">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="services-icon-circle4">
                            
                                <h2 className="services-icon my-auto">١.</h2>
                                
                            </div>
                           
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            </div>
                        </div>
                        
                        <div className="services-body ">
                        يعد الاقتصاد المزدهر أحد الأسس الرئيسة لرؤية المملكة العربية السعودية 2030، وقد رسخت الرؤية الطموحة دور مساحات العمل المشتركة ومسرعات وحاضنات الأعمال وأسهمت في نموها، ورفع كفائتها وتوجيه الاهتمام المشترك لتطويرها ونموها، لما تشكله المنشآت الصغيرة والمتوسطة من أهمية كبيرة في دفع عجلة التنمية الاقتصادية على الصعيد العالمي والمحلي
                        </div>
                    </div>

                       
                        <div className="col-12 col-md-6 ">
                <div className="services-header mx-auto">
                            <div className="circles-container mb-5">
                            <div className="services-icon-circle5"></div>
                            <div className="services-icon-circle4">
                            
                                <h2 className="services-icon my-auto">٢.</h2>
                                
                            </div>
                           
                            <div className="o-overlap-top__deco o-aspect-ratio"></div>
                            </div>
                        </div>
                        
                        <div className="services-body ">
                        من هنا يأتي دور شركة هاد مرشد الأعمال لما له من أثر بالغ في إرشاد المشاريع الناشئة، والمساهمة في نموها ، إذ تعد شركة هاد مرشد الأعمال من أهم مسرعات الأعمال المتخصصة في إسناد الخدمات المساندة لقطاع المنشآت الصغيرة والمتوسطة، حيث تنفرد بتقديم خدمات الإسناد الكامل أو الجزئي عبر خدمات تكاملية تساهم في منح أصحاب الأعمال وقت أكبر للتفرغ لإدارة أعمالهم وتطويرها
                        </div>
                    </div>

                        </div>
                         </div> */}
                         </div>
                         
                      
    )
}
